// Mock data for Laura Sommerfeld Landing Page

export const artistInfo = {
  name: "Laura Sommerfeld",
  tagline: "Moderne Schlagermusik mit Herz und Leidenschaft",
  bio: "Laura Sommerfeld verbindet traditionelle Schlagerwerte mit modernen Beats und einer frischen, jungen Energie. Mit ihrer einzigartigen Stimme und ihrer charismatischen Bühnenpräsenz begeistert die 28-jährige Künstlerin ihr Publikum deutschlandweit.",
  fullBio: "Seit ihrem Durchbruch vor drei Jahren hat Laura Sommerfeld die deutsche Schlagerszene im Sturm erobert. Ihre Musik zeichnet sich durch eingängige Melodien, emotionale Texte und eine moderne Produktion aus, die traditionelle Schlagerwerte mit zeitgenössischen Pop-Elementen verbindet. Auf der Bühne begeistert sie mit ihrer energiegeladenen Performance und ihren ikonischen Paillettenkleidern in metallischen Blau- und Silbertönen.",
  youtubeVideoId: "gnEOuWAlwp8",
  spotifyEmbedUrl: "https://open.spotify.com/embed/artist/6u641ROltnGm8t4c0GfvGn",
};

export const socialMedia = {
  instagram: "https://www.instagram.com/laura.sommerfeld.official/",
  facebook: "https://www.facebook.com/Laura.Sommerfeld.Official",
  tiktok: "https://www.tiktok.com/@laura.sommerfeld",
  youtube: "https://www.youtube.com/channel/UCRYmeEYiz272NKmGWw8Nfcg",
  spotify: "https://open.spotify.com/intl-de/artist/6u641ROltnGm8t4c0GfvGn",
};

export const tourDates = [
  {
    id: 1,
    date: "2025-03-15",
    venue: "Konzerthaus Berlin",
    city: "Berlin",
    country: "Deutschland",
    ticketLink: "#",
  },
  {
    id: 2,
    date: "2025-04-20",
    venue: "Elbphilharmonie",
    city: "Hamburg",
    country: "Deutschland",
    ticketLink: "#",
  },
  {
    id: 3,
    date: "2025-05-10",
    venue: "Alte Oper",
    city: "Frankfurt",
    country: "Deutschland",
    ticketLink: "#",
  },
  {
    id: 4,
    date: "2025-06-18",
    venue: "Olympiahalle",
    city: "München",
    country: "Deutschland",
    ticketLink: "#",
  },
  {
    id: 5,
    date: "2025-07-22",
    venue: "Lanxess Arena",
    city: "Köln",
    country: "Deutschland",
    ticketLink: "#",
  },
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_sommertunes-laura/artifacts/55gxbjh1_image_81dd387b.jpg",
  about: "https://customer-assets.emergentagent.com/job_sommertunes-laura/artifacts/aj2ji6ya_715a826d799a1d66334e33be78943075_1772720094_ctr86lnk.jpg",
  performance1: "https://customer-assets.emergentagent.com/job_sommertunes-laura/artifacts/p5bzydi3_wilderkaiser_A_beautiful_30-year-old_woman_singing_passionate_6b77e7e6-3caf-44e8-b4b7-4285a4f4d309_1.png",
  performance2: "https://customer-assets.emergentagent.com/job_sommertunes-laura/artifacts/1l3ldq2c_image_dd0c6862.jpg",
  accent: "https://customer-assets.emergentagent.com/job_sommertunes-laura/artifacts/l5jzckbq_laura%20Sommerfeld%20-%20Du%20fehlst%20mir%20so%20Musicvideo.jpg",
};
